import styled from 'styled-components';

export const ListViewContainer = styled.div`
  width: 100%;
  height: calc(100vh - 280px);
  display: flex;
  position: relative;
`;
